unit uWMStand;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, System.DateUtils, WEBLib.WebCtrls, WEBLib.REST, WEBLib.JSON;

type
  TfrmWMStand = class(TForm)
    pnTop: TPanel;
    btYear2025: TButton;
    btYear2026: TButton;
    divWMStand: THTMLDiv;
    btViewDrivers: TButton;
    btViewTeams: TButton;
    restRequest: THttpRequest;
    procedure btYear2025Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure restRequestResponse(Sender: TObject; AResponse: string);
    procedure btViewDriversClick(Sender: TObject);
    procedure restRequestError(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
      var Handled: Boolean);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    year: integer;
    view: smallint; //0= Fahrer, 1= Teams
    procedure RefreshGrid;
  protected procedure LoadDFMValues; override; end;

var
  frmWMStand: TfrmWMStand;
  tabDriver: JSValue;

implementation

{$R *.dfm}

procedure TfrmWMStand.btViewDriversClick(Sender: TObject);
begin
   if (Sender = btViewDrivers) then
  begin
    btViewDrivers.ElementHandle.classList.remove('btn-outline-primary');
    btViewDrivers.ElementHandle.classList.add('btn-primary');
    btViewTeams.ElementHandle.classList.remove('btn-primary');
    btViewTeams.ElementHandle.classList.add('btn-outline-primary');
    View := 0; //Fahrer
    asm
      var col = this.tabDriver.getColumn("name");
      if (col) {
        col.updateDefinition({ title: "Fahrer" });
      }
    end;
  end else
  begin
    btViewTeams.ElementHandle.classList.remove('btn-outline-primary');
    btViewTeams.ElementHandle.classList.add('btn-primary');
    btViewDrivers.ElementHandle.classList.remove('btn-primary');
    btViewDrivers.ElementHandle.classList.add('btn-outline-primary');
    View := 1; //Teams
    asm
      var col = this.tabDriver.getColumn("name");
      if (col) {
        col.updateDefinition({ title: "Team" });
      }
    end;
  end;
  RefreshGrid;
end;

procedure TfrmWMStand.btYear2025Click(Sender: TObject);
begin
  //Bei noch mehr Jahren etwas eleganter lösen
  if (Sender = btYear2025) then
  begin
    btYear2025.ElementHandle.classList.remove('btn-outline-primary');
    btYear2025.ElementHandle.classList.add('btn-primary');
    btYear2026.ElementHandle.classList.remove('btn-primary');
    btYear2026.ElementHandle.classList.add('btn-outline-primary');
    year := 2025;
  end else
  begin
    btYear2026.ElementHandle.classList.remove('btn-outline-primary');
    btYear2026.ElementHandle.classList.add('btn-primary');
    btYear2025.ElementHandle.classList.remove('btn-primary');
    btYear2025.ElementHandle.classList.add('btn-outline-primary');
    year := 2026;
  end;

  RefreshGrid;
end;

procedure TfrmWMStand.RefreshGrid;
var
  url: string;
begin
  url := 'https://api.jolpi.ca/ergast/f1/' + year.ToString + '/';
  if (view = 0) then //Fahrer
    url :=url + 'driverstandings'
  else if (view = 1) then //Teams
    url := url + 'constructorstandings';

  restRequest.URL := url;
  restRequest.execute;
end;

procedure TfrmWMStand.restRequestError(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
  var Handled: Boolean);
begin
  ShowMessage('Error: ');
end;

procedure TfrmWMStand.restRequestResponse(Sender: TObject; AResponse: string);
var
  Root, MRData, StandingsTable, SL0: TJSONObject;
  SLArr, DSArr: TJSONArray;
  i: Integer;
  DS, Driver, Team: TJSONObject;
  givenName, familyName, fullName, points, position: string;
begin

  Root := TJSONObject.ParseJSONValue(AResponse) as TJSONObject;
  try
    MRData := Root.GetValue('MRData') as TJSONObject;
    StandingsTable := (MRData.GetValue('StandingsTable') as TJSONObject);

    SLArr := StandingsTable.GetValue('StandingsLists') as TJSONArray;
    if (SLArr = nil) or (SLArr.Count = 0) then
    begin
      asm
        var empty = [];
        this.tabDriver.replaceData(empty);
      end;
      exit;
    end;

    SL0 := SLArr.Items[0] as TJSONObject;

    if (View = 0) then
      DSArr := SL0.GetValue('DriverStandings') as TJSONArray
    else
      DSArr := SL0.GetValue('ConstructorStandings') as TJSONArray;
    // Flache JS-Daten bauen und an Tabulator geben
    asm
      var rows = [];
    end;

    for i := 0 to DSArr.Count - 1 do
    begin
      DS := DSArr.Items[i] as TJSONObject;
      position := IntToStr(i + 1);
      points := (DS.GetValue('points') as TJSONString).Value;

      if (View = 0) then //Fahrer
      begin
        Driver := DS.GetValue('Driver') as TJSONObject;
        givenName := (Driver.GetValue('givenName') as TJSONString).Value;
        familyName := (Driver.GetValue('familyName') as TJSONString).Value;
        fullName := givenName + ' ' + familyName;

      end else if (View = 1) then //Teams
      begin
        Team := DS.GetValue('Constructor') as TJSONObject;
        fullname := (Team.GetValue('name') as TJSONString).Value;
      end;

      asm
        rows.push({position: position, name: fullName, points: parseFloat(points) });
      end;
    end;

    asm
      this.tabDriver.replaceData(rows);
    end;

  finally
    Root.Free;
  end;

end;

procedure TfrmWMStand.WebFormCreate(Sender: TObject);
var
  DataArray: TJSArray;
begin
  year := YearOf(Now);
  view := 0; //Fahrer



  // Define an empty table, attach it to the TWebHTML component that has an ElementID of 'tabExample'
  //{field: "POS",    title: "Pos.", width:    100, resizable: false, vertAlign: "middle", hozAlign: "center"},
  asm
    this.tabDriver = new Tabulator("#tabDriver", {
      layout: "fitColumns",
      reactiveData: true,
      columns: [
        {title:"", field:"position", width: 50, hozAlign:"center", sorter:"integer"},
        {title:"Fahrer", field:"name", width: 200,  sorter:"string"},
        {title:"Punkte", field:"points", width: 100, sorter:"number", hozAlign:"center"}
      ]

    });


  end;
  RefreshGrid;
end;

procedure TfrmWMStand.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnTop := TPanel.Create(Self);
  btYear2025 := TButton.Create(Self);
  btYear2026 := TButton.Create(Self);
  btViewDrivers := TButton.Create(Self);
  btViewTeams := TButton.Create(Self);
  divWMStand := THTMLDiv.Create('tabDriver');
  restRequest := THttpRequest.Create(Self);

  pnTop.BeforeLoadDFMValues;
  btYear2025.BeforeLoadDFMValues;
  btYear2026.BeforeLoadDFMValues;
  btViewDrivers.BeforeLoadDFMValues;
  btViewTeams.BeforeLoadDFMValues;
  divWMStand.BeforeLoadDFMValues;
  restRequest.BeforeLoadDFMValues;
  try
    Name := 'frmWMStand';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnTop.SetParentComponent(Self);
    pnTop.Name := 'pnTop';
    pnTop.Left := 0;
    pnTop.Top := 0;
    pnTop.Width := 640;
    pnTop.Height := 60;
    pnTop.Align := alTop;
    pnTop.BorderColor := 16316922;
    pnTop.BorderStyle := bsNone;
    pnTop.ChildOrder := 1;
    pnTop.Color := 16316922;
    pnTop.TabOrder := 0;
    btYear2025.SetParentComponent(pnTop);
    btYear2025.Name := 'btYear2025';
    btYear2025.Left := 8;
    btYear2025.Top := 11;
    btYear2025.Width := 81;
    btYear2025.Height := 38;
    btYear2025.Caption := '2025';
    btYear2025.ElementClassName := 'btn btn-outline-primary';
    btYear2025.ElementFont := efCSS;
    btYear2025.HeightPercent := 100.000000000000000000;
    btYear2025.WidthPercent := 100.000000000000000000;
    SetEvent(btYear2025, Self, 'OnClick', 'btYear2025Click');
    btYear2026.SetParentComponent(pnTop);
    btYear2026.Name := 'btYear2026';
    btYear2026.Left := 94;
    btYear2026.Top := 11;
    btYear2026.Width := 81;
    btYear2026.Height := 38;
    btYear2026.Caption := '2026';
    btYear2026.ChildOrder := 1;
    btYear2026.ElementClassName := 'btn btn-primary';
    btYear2026.ElementFont := efCSS;
    btYear2026.HeightPercent := 100.000000000000000000;
    btYear2026.WidthPercent := 100.000000000000000000;
    SetEvent(btYear2026, Self, 'OnClick', 'btYear2025Click');
    btViewDrivers.SetParentComponent(pnTop);
    btViewDrivers.Name := 'btViewDrivers';
    btViewDrivers.Left := 461;
    btViewDrivers.Top := 11;
    btViewDrivers.Width := 83;
    btViewDrivers.Height := 38;
    btViewDrivers.Anchors := [akTop,akRight];
    btViewDrivers.Caption := 'Fahrer';
    btViewDrivers.ChildOrder := 1;
    btViewDrivers.ElementClassName := 'btn btn-primary';
    btViewDrivers.ElementFont := efCSS;
    btViewDrivers.HeightPercent := 100.000000000000000000;
    btViewDrivers.WidthPercent := 100.000000000000000000;
    SetEvent(btViewDrivers, Self, 'OnClick', 'btViewDriversClick');
    btViewTeams.SetParentComponent(pnTop);
    btViewTeams.Name := 'btViewTeams';
    btViewTeams.Left := 549;
    btViewTeams.Top := 11;
    btViewTeams.Width := 83;
    btViewTeams.Height := 38;
    btViewTeams.Anchors := [akTop,akRight];
    btViewTeams.Caption := 'Teams';
    btViewTeams.ChildOrder := 1;
    btViewTeams.ElementClassName := 'btn btn-outline-primary';
    btViewTeams.ElementFont := efCSS;
    btViewTeams.HeightPercent := 100.000000000000000000;
    btViewTeams.WidthPercent := 100.000000000000000000;
    SetEvent(btViewTeams, Self, 'OnClick', 'btViewDriversClick');
    divWMStand.SetParentComponent(Self);
    divWMStand.Name := 'divWMStand';
    divWMStand.Left := 4;
    divWMStand.Top := 64;
    divWMStand.Width := 631;
    divWMStand.Height := 407;
    divWMStand.Anchors := [akLeft,akTop,akRight,akBottom];
    divWMStand.ChildOrder := 2;
    divWMStand.Role := '';
    restRequest.SetParentComponent(Self);
    restRequest.Name := 'restRequest';
    restRequest.URL := 'https://api.jolpi.ca/ergast/f1/2025/driverstandings';
    SetEvent(restRequest, Self, 'OnError', 'restRequestError');
    SetEvent(restRequest, Self, 'OnResponse', 'restRequestResponse');
    restRequest.Left := 388;
    restRequest.Top := 168;
  finally
    pnTop.AfterLoadDFMValues;
    btYear2025.AfterLoadDFMValues;
    btYear2026.AfterLoadDFMValues;
    btViewDrivers.AfterLoadDFMValues;
    btViewTeams.AfterLoadDFMValues;
    divWMStand.AfterLoadDFMValues;
    restRequest.AfterLoadDFMValues;
  end;
end;

end.